import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const usePlanejamentoDetalhadoNavegacao = () => {
  const history = useHistory();
  const handleRowClick = useCallback(row => {
    console.log('🖱️ Clicou na linha:', row);
    history.push(`/pages/planejamentodetalhado/sugestao/${row.id}`);
  }, [history]);
  const handleAdicionar = useCallback(() => {
    console.log('➕ Botão adicionar clicado');
    history.push('/pages/planejamentodetalhado/criar');
  }, [history]);
  const handleEditar = useCallback(id => {
    console.log('✏️ Editando pedido:', id);
    history.push(`/pages/planejamentodetalhado/editar/${id}`);
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
